import moment from 'moment';
import { Space } from 'antd';
import { Link } from 'react-router-dom';
import DeclarationStatusTag from 'components/ui/composed/declarations/declaration-status/DeclarationStatusTag';
import { getDeclarationPageHeaderTitle } from 'views/declarations/declaration-tabs/declaration-form/utils/getDeclarationPageTitle';
import { Declaration } from 'store/declarations/declaration';
import DotSeparator from 'components/new-ui/base/dot-separator/DotSeparator';

type Props = {
    declaration: Declaration;
    to?: string;
};

const ExistingDeclarationInfo = ({ declaration, to }: Props) => {
    const pageTitle = getDeclarationPageHeaderTitle(declaration);

    return (
        <Space size={6} style={{ flexWrap: 'wrap' }}>
            <Space>
                <DeclarationStatusTag status={declaration.status} hideText />
                {to ? (
                    <Link to={to} target="_blank" rel="opener" style={{ textDecoration: 'underline' }}>
                        {pageTitle}
                    </Link>
                ) : (
                    pageTitle
                )}
            </Space>

            {declaration.mrn && <DotSeparator />}
            {declaration.mrn && 'MRN: ' + declaration.mrn}

            {declaration.individual?.name && <DotSeparator />}
            {declaration.individual?.name && `Created by: ${declaration.individual?.name}`}

            {declaration.createdAt && <DotSeparator />}
            {declaration.createdAt && moment(declaration.createdAt).format('DD/MM/YY, HH:mm')}
        </Space>
    );
};

export default ExistingDeclarationInfo;
